<div class="container" [class.minified]="isMinified">
  @if (!isMinified) {
    <span
      class="close-btn side-menu-close cursor-pointer rounded-full w-[24px] h-[24px] items-center justify-center flex -mr-1"
      (click)="closeMenu()"
    >
      <i class="fa-regular fa-xmark"></i>
    </span>
  }
  @if (isMinified) {
    <div
      class="flex flex-col justify-center items-center w-full side-menu-toggle"
      (click)="open.emit()"
    >
      <i class="fa-regular fa-bars"></i>
    </div>
  }
  @if (!isMinified) {
    <div class="flex flex-col w-full items-center user-info" (click)="open.emit()">
      <div class="side-menu-branding px-8 py-4"></div>
      <soft-widget-outlet class="w-full" [name]="'sideMenuUserInfo'"></soft-widget-outlet>
    </div>
  }

  <div class="menu-item-container soft-scroll vertical no-horizontal">
    <soft-menu-outlet name="nav-static" #navStatic></soft-menu-outlet>
    @if (
      navStatic.menuItems().length > 0 &&
      (navPinned.menuItems().length > 0 || nav.menuItems().length > 0)
    ) {
      <soft-menu-separator></soft-menu-separator>
    }
    <soft-menu-outlet name="nav-pinned" #navPinned></soft-menu-outlet>
    @if (navPinned.menuItems().length > 0 && nav.menuItems().length > 0) {
      <soft-menu-separator></soft-menu-separator>
    }
    <soft-menu-outlet name="nav" #nav></soft-menu-outlet>

    @for (command of topCommands$ | async; track command) {
      @if (command.isVisible ? (command.isVisible | async) : true) {
        <div
          [id]="'framework-application-shell-menu-commands-top-' + command.name"
          class="flex flex-row w-full justify-start items-center menu-item flex-nowrap relative"
          softToolTip="{{ command.name | translate }}"
          toolTipPosition="right"
          [toolTipVisible]="isMinified"
          *ngVar="command.canExecute ? (command.canExecute | async) : true as canExecute"
          [class.disabled]="!canExecute"
          [class.active]="command.routerLink | isActiveRoute"
          [ngClass]="command.class"
          (click)="
            onClick(
              command.execute,
              command.routerLink,
              canExecute,
              command.routerLinkParams
            )
          "
        >
          @if (command?.badge | async; as badge) {
            <span class="soft-badge">{{ badge }}</span>
          }
          @if (command.icon) {
            <span
              class="flex flex-row justify-center command-icon"
              [class.minified]="isMinified"
            >
              <soft-icon [name]="command.icon"></soft-icon>
            </span>
          }
          @if (!isMinified) {
            <span class="ml-2">{{ command.name | translate }}</span>
          }
        </div>
        @if (command.routerLink | isActiveRoute: { paths: 'subset' }) {
          @for (subCommand of command.commands; track subCommand) {
            <div
              class="flex flex-row w-full menu-item flex-nowrap sub-menu-item relative"
              softToolTip="{{ subCommand.name | translate }}"
              toolTipPosition="right"
              [toolTipVisible]="isMinified"
              *ngVar="
                subCommand.canExecute
                  ? (subCommand.canExecute | async)
                  : true as canExecute
              "
              [class.disabled]="!canExecute"
              [ngClass]="subCommand.class"
              [class.active]="subCommand.routerLink | isActiveRoute"
              (click)="
                onClick(
                  subCommand.execute,
                  subCommand.routerLink,
                  canExecute,
                  subCommand.routerLinkParams
                )
              "
            >
              @if (command?.badge | async; as badge) {
                <span class="soft-badge">{{ badge }}</span>
              }
              @if (subCommand.icon) {
                <span
                  class="flex flex-row justify-center command-icon"
                  [class.minified]="isMinified"
                >
                  <soft-icon [name]="subCommand.icon"></soft-icon>
                </span>
              }
              @if (!isMinified) {
                <span class="ml-2">{{ subCommand.name | translate }}</span>
              }
            </div>
          }
        }
      }
    }

    <div class="menu-container-bottom">
      <soft-menu-outlet name="nav-bottom" #navStatic></soft-menu-outlet>

      @for (command of bottomCommands$ | async; track command) {
        @if (command.isVisible ? (command.isVisible | async) : true) {
          <div
            [id]="'framework-application-shell-menu-commands-bottom-' + command.name"
            class="flex flex-row menu-item flex-nowrap relative"
            softToolTip="{{ command.name | translate }}"
            toolTipPosition="right"
            *ngVar="
              command.canExecute ? (command.canExecute | async) : true as canExecute
            "
            [class.active]="command.routerLink | isActiveRoute"
            [class.disabled]="!canExecute"
            [ngClass]="command.class"
            (click)="
              onClick(
                command.execute,
                command.routerLink,
                canExecute,
                command.routerLinkParams
              )
            "
          >
            @if (command?.badge | async; as badge) {
              <span class="soft-badge">{{ badge }}</span>
            }
            @if (command.icon) {
              <span
                class="flex flex-row justify-center command-icon"
                [class.minified]="isMinified"
              >
                <soft-icon [name]="command.icon"></soft-icon>
              </span>
            }
            @if (!isMinified) {
              <span class="ml-2">{{ command.name | translate }}</span>
            }
          </div>
        }
      }
      @if (((version$ | async) || (name$ | async)) && !isMinified) {
        <div class="flex flex-row justify-center menu-version-info">
          {{ name$ | async }} {{ version$ | async }}
        </div>
      }
    </div>
  </div>
</div>
